import classNames from 'classnames';
import React__default from 'react';
import BsDropdown from 'reactstrap/lib/Dropdown';
import DropdownMenu from 'reactstrap/lib/DropdownMenu';
import DropdownToggle from 'reactstrap/lib/DropdownToggle';
import Styles from './Dropdown.module.scss.js';

const Dropdown = ({ id, children, DropdownToggleBtn, isOpen = false, handleToggle, containerClassName, dropdownClassName, dropdownToggleClassName, disabled, direction, onBlur }) => {
    return (React__default.createElement("div", { className: containerClassName },
        React__default.createElement(BsDropdown, { isOpen: isOpen, toggle: handleToggle, direction: direction, onBlur: onBlur, id: id },
            React__default.createElement(DropdownToggle, { className: classNames(`${isOpen ? "active" : ""}`, dropdownToggleClassName), disabled: disabled, tag: "span" }, DropdownToggleBtn),
            React__default.createElement(DropdownMenu, { className: classNames(Styles.dropdownMenu, dropdownClassName), style: { zIndex: 9999 }, translate: "no" }, children))));
};

export { Dropdown as default };
//# sourceMappingURL=Dropdown.js.map
